import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const API = {
    URL_PRODUCT: '/rest/v2/{site}/products/{productCode}',
};

if (checkShouldUseMocks()) {
    API.URL_PRODUCT = '/api/eshop-product/product/{productCode}';
}

export const Z_INDEX_MODAL = 1051;
